export default __webpack_public_path__ + "static/media/no-marble-modal.4ae97d9b.png";